import React from 'react';
import ComingSoon from '../../../../../shared/defaultPages/comingSoon';

const Plan = () => <ComingSoon />;

export default Plan;
